<template>
    <form-wrapper :columns="2" :form-title="$t('searchQuery.queryFields')">
        <template v-for="field in sortedFields">
            <filter-input-number v-if="field.type.toLowerCase() == 'float'"
                                 :precision="field.precision != undefined ? field.precision : 1"
                                 :caption="field.caption"
                                 v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-input-number v-if="field.type.toLowerCase() == 'decimal'"
                                 :precision="field.precision != undefined ? field.precision : 1"
                                 :caption="field.caption"
                                 v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-input-number v-if="field.type.toLowerCase() == 'integer'"
                                 :precision="field.precision != undefined ? field.precision : 1"
                                 :caption="field.caption"
                                 v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-input-string v-if="field.type.toLowerCase() == 'string'" :caption="field.caption"
                                 v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-entity-input-selection v-if="field.type.toLowerCase() == 'entity'" :caption="field.caption"
                                           :options="field.options"
                                           v-model="query.parameters[field.name]" @input="handleInput"
                                           :object="field.object"/>
            <filter-input-selection v-if="field.type.toLowerCase() == 'boolean'" :caption="field.caption" type="boolean"
                                    v-model="query.parameters[field.name]" @input="handleInput"
                                    :options="[{id: 'false', name: $t('no')}, {id: 'true', name: $t('yes')}]"/>
            <filter-input-selection v-if="field.type.toLowerCase() == 'enum'" :caption="field.caption"
                                    :options="field.options"
                                    v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-input-date v-if="field.type.toLowerCase() == 'date'" :caption="field.caption"
                               v-model="query.parameters[field.name]" @input="handleInput"/>
            <filter-input-geo-point v-if="field.type.toLowerCase() == 'geo_point'" :caption="field.caption"
                                    v-model="query.parameters[field.name]" @input="handleInput"/>
        </template>
    </form-wrapper>
</template>

<script>
import FormWrapper from "../form/FormWrapper";
import FilterInputNumber from "./FilterInputNumber";
import FilterInputString from "./FilterInputString";
import FilterInputSelection from "./FilterInputSelection";
import FilterInputDate from "./FilterInputDate";
import FilterInputGeoPoint from './FilterInputGeoPoint'
import FilterEntityInputSelection from "./FilterEntityInputSelection";

export default {
    name: "FilterForm",
    components: {
        FilterEntityInputSelection,
        FilterInputDate, FilterInputSelection, FilterInputString, FilterInputNumber, FormWrapper, FilterInputGeoPoint
    },
    props: {
        filterDefinition: Object,
        value: Object
    },
    data: function () {
        return {
            query: {
                parameters: {}
            }
        }
    },
    methods: {
        handleInput() {
            this.$emit('input', this.query)
        }
    },
    computed: {
        sortedFields() {
            return this.filterDefinition.fields.sort((a, b) => {
                return a.caption.localeCompare(b.caption)
            })
        }
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                // console.log("formVal", newVal)
                if (newVal == undefined || newVal == null || newVal.id === null) {

                    this.$set(this, 'query', {parameters: {}});
                    this.handleInput();
                } else {
                    this.$set(this, 'query', this.$_.cloneDeep(newVal))
                }
            },
            immediate: true
        },
    }
}
</script>

<style scoped>

</style>